"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PhishingListService = void 0;
const axios_1 = __importDefault(require("axios"));
const utils_1 = require("./utils");
class IntervalFetcher {
    constructor(opts, handler) {
        this.opts = opts;
        this.handler = handler;
        this._hasInited = false;
        this._hasStopped = false;
    }
    get hasInited() {
        return this._hasInited;
    }
    start() {
        this.fetch();
    }
    stop() {
        if (this.timeoutId != null) {
            clearTimeout(this.timeoutId);
            this.timeoutId = undefined;
        }
        this._hasStopped = true;
    }
    fetch() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.timeoutId != null) {
                clearTimeout(this.timeoutId);
                this.timeoutId = undefined;
            }
            if (this._hasStopped) {
                return;
            }
            let failed = false;
            try {
                const res = yield axios_1.default.get(this.opts.url);
                this.handler(res);
                this._hasInited = true;
            }
            catch (e) {
                failed = true;
                console.log(e);
            }
            if (!this._hasStopped) {
                this.timeoutId = setTimeout(() => {
                    this.fetch();
                }, failed ? this.opts.retryIntervalMs : this.opts.fetchingIntervalMs);
            }
        });
    }
}
class PhishingListService {
    constructor(opts) {
        this.opts = opts;
        this.urlMap = new Map();
        this.allowedUrlMap = new Map();
        this.twitterMap = new Map();
        this.urlFetcher = new IntervalFetcher(Object.assign(Object.assign({}, this.opts), { url: this.opts.blockListUrl }), (res) => {
            const domains = res.data
                .split(/(\r?\n)|,|;|\s|\t/)
                .filter((str) => str != null)
                .map((str) => {
                return str.trim();
            })
                .filter((str) => str.length > 0);
            const map = new Map();
            for (const domain of domains) {
                try {
                    map.set(utils_1.parseDomainUntilSecondLevel(domain), true);
                }
                catch (e) {
                    console.log(e);
                }
            }
            this.urlMap = map;
        });
        if (this.opts.twitterListUrl) {
            this.twitterFetcher = new IntervalFetcher(Object.assign(Object.assign({}, this.opts), { url: this.opts.twitterListUrl }), (res) => {
                const ids = res.data
                    .split(/(\r?\n)|,|;|\s|\t/)
                    .filter((str) => str != null)
                    .map((str) => {
                    return str.trim();
                })
                    .filter((str) => str.length > 0);
                const map = new Map();
                for (const id of ids) {
                    map.set(id.replace("@", "").toLowerCase(), true);
                }
                this.twitterMap = map;
            });
        }
    }
    init() {
        this.urlFetcher.start();
        if (this.twitterFetcher) {
            this.twitterFetcher.start();
        }
    }
    get hasInited() {
        return (this.urlFetcher.hasInited &&
            (!this.twitterFetcher || this.twitterFetcher.hasInited));
    }
    stop() {
        this.urlFetcher.stop();
        if (this.twitterFetcher) {
            this.twitterFetcher.stop();
        }
    }
    checkURLIsPhishing(url) {
        const parsed = utils_1.parseDomainUntilSecondLevel(new URL(url).origin);
        if (this.urlMap.get(parsed) === true) {
            const allowed = this.allowedUrlMap.get(parsed);
            if (allowed &&
                allowed + this.opts.allowTimeoutMs >= new Date().getTime()) {
                return false;
            }
            return true;
        }
        else {
            return false;
        }
    }
    allowUrlTemp(url) {
        const parsed = new URL(url);
        this.allowedUrlMap.set(utils_1.parseDomainUntilSecondLevel(parsed.origin), new Date().getTime());
    }
    checkBadTwitterId(id) {
        return this.twitterMap.get(id.replace("@", "").toLowerCase()) === true;
    }
}
exports.PhishingListService = PhishingListService;
//# sourceMappingURL=service.js.map